import { createFileRoute, useNavigate, Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { OrderForm, useCreateOrder } from "@/features/orders";
import type { OrderCreate } from "@cold-crew/shared";

export const Route = createFileRoute("/_app/pedidos/nuevo")({
  component: NuevoPedidoPage,
});

function NuevoPedidoPage() {
  const navigate = useNavigate();
  const createOrder = useCreateOrder();

  async function handleSubmit(data: OrderCreate) {
    await createOrder.mutateAsync(data);
    navigate({ to: "/pedidos" });
  }

  return (
    <div className="min-h-full bg-[#f4f1ea]">
      <div className="border-b border-[#ded9cf] bg-[#f8f6f1]">
        <div className="mx-auto flex max-w-[1280px] items-center gap-3 px-4 py-3 lg:px-5">
          <Link
            to="/pedidos"
            className="flex size-8 items-center justify-center rounded-lg text-[#6f6a62] transition-colors hover:bg-[#ebe7df] hover:text-[#171614]"
            aria-label="Regresar a pedidos"
          >
            <ArrowLeft className="size-4" />
          </Link>

          <div>
            <h1 className="text-[18px] font-black leading-tight tracking-[-0.03em] text-[#171614]">
              Nuevo pedido
            </h1>
            <p className="mt-0.5 text-[11px] font-medium text-[#8b867e]">
              Llena los datos y agrega productos
            </p>
          </div>
        </div>
      </div>

      <main className="mx-auto w-full max-w-[1280px] px-3 py-3 sm:px-4 lg:px-5">
        <OrderForm
          onSubmit={handleSubmit}
          isLoading={createOrder.isPending}
          submitLabel="Crear pedido"
        />
      </main>
    </div>
  );
}
